export interface ApiError {
  readonly error: string;
  readonly message: string;
  readonly path: string;
  readonly status: number;
  readonly timestamp: string;
  readonly details?: string[];
}

export const isApiErrorParams = (data: any): data is ApiError => {
  return data
    && (data as ApiError).error !== undefined
    && (data as ApiError).message !== undefined
    && (data as ApiError).path !== undefined
    && (data as ApiError).status !== undefined
    && (data as ApiError).timestamp !== undefined;
}
